import React, { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import { AdvancedImage } from "@cloudinary/react";
import { Cloudinary } from "@cloudinary/url-gen";
import { auto, fill } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import {
  extractCloudinaryPublicId,
  getCloudinaryCloudName,
} from "../utils/cloudinaryMedia";

const PhotoViewerModal = ({
  isOpen,
  onClose,
  photos,
  reportDate,
  projectName,
  projectAddress,
}) => {
  const cloudinary = useMemo(
    () =>
      new Cloudinary({
        cloud: { cloudName: getCloudinaryCloudName() },
      }),
    []
  );

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full sm:w-11/12 md:w-4/5 lg:w-3/5 xl:w-2/5 max-h-screen overflow-y-auto">
        <div className="sticky top-0 bg-white border-b p-4 flex justify-between items-center z-10">
          <div>
            <h2 className="text-xl font-bold">
              Viewing {photos.length} {photos.length === 1 ? "photo" : "photos"}{" "}
              - {reportDate}
            </h2>
            <p className="text-gray-600 text-sm">
              {projectName}, {projectAddress}
            </p>
          </div>
          <button
            className="text-black hover:text-gray-700"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes className="w-6 h-6" />
          </button>
        </div>
        <div className="p-4 space-y-4">
          {photos?.map((photo, idx) => {
            const publicId = extractCloudinaryPublicId(photo);
            if (!publicId) return null;

            const cloudinaryImage = cloudinary
              .image(publicId)
              .format("auto")
              .quality("auto")
              .resize(
                auto()
                  .gravity(autoGravity())
                  .width(1024)
                  .height(1024)
              );

            return (
              <AdvancedImage
                key={idx}
                cldImg={cloudinaryImage}
                alt={`Time Report Photo ${idx + 1}`}
                className="w-full rounded"
              />
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PhotoViewerModal;
